export const apiEndpoint = process.env.NEXT_PUBLIC_API_ENDPOINT;
export const isBrowser = typeof window !== 'undefined';
